import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 10325 15090"
    {...props}
  >
    <path
      d="M4645 5925c619 0 1152-183 1599-544 448-365 671-884 671-1565 0-516-179-964-536-1335-355-375-836-561-1442-561-409 0-747 58-1011 172-265 113-475 265-630 454-155 186-303 430-440 726-138 296-262 575-379 836-65 141-186 255-361 334-176 82-375 120-606 120-268 0-516-106-739-327-227-217-337-509-337-870 0-351 103-716 316-1105 213-385 520-753 929-1100 406-352 912-630 1514-843C3798 107 4476 0 5219 0c654 0 1249 90 1786 268 536 176 1004 434 1404 771 395 334 694 723 897 1166 200 444 303 922 303 1432 0 671-148 1249-440 1727-293 481-712 949-1256 1407 523 282 967 602 1328 967 358 361 630 763 812 1204 182 440 272 915 272 1424 0 613-124 1201-368 1772-248 571-609 1080-1087 1527-475 448-1043 795-1700 1046-654 252-1380 379-2171 379-809 0-1531-145-2167-434-640-289-1163-650-1580-1083-413-431-722-881-935-1342-214-465-317-847-317-1149 0-389 124-702 379-943 251-237 564-358 942-358 186 0 368 55 544 169 172 110 289 241 340 395 351 936 726 1628 1125 2082 400 454 964 681 1690 681 416 0 815-103 1204-306 385-207 705-509 956-912 251-406 379-870 379-1403 0-785-214-1401-644-1848s-1028-671-1796-671c-134 0-344 14-626 41-282 28-461 38-543 38-369 0-654-89-857-275s-303-440-303-771c0-323 121-581 365-781 241-196 599-295 1077-295h413z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
